<div class="d-flex flex-column">
  @if (badgeLabel) {
    <label class="badge-lable truncate"
      >{{
      badgeLabel | translate
    }}</label>
  }
  @if (badgeType !== badgeTypeEnum.trafficLigth) {
    <div
      [class]="'badge badge-pill truncate' + internalBadgeClass"
       [ngClass]="{
      'badge-glow': badgeColorType === badgeColorTypeEnum.glow,
      'badge-with-lable': badgeLabel
    }"
      [ngbTooltip]="badgeToolTip"
      [placement]="badgeToolTipPlacement"
      container="body">
      @if (badgeType === badgeTypeEnum.status) {
        <div
          class="cursor-dafault d-flex align-items-center justify-content-center">
          @if (badgeIcon && badgeIconPosition === 'left') {
            <span
              [data-feather]="badgeIcon"
            [class]="'mr-25'"></span>
          }
          <span style="font-size: 12px">{{ badgeText | translate }} @if (badgeText2) {
            <span> - {{ badgeText2 | translate
            }}</span>
          }</span>
          @if (badgeIcon && badgeIconPosition === 'right') {
            <span
              [data-feather]="badgeIcon"
            [class]="'ml-25'"></span>
          }
        </div>
      }
      @if (badgeType === badgeTypeEnum.link) {
        <a
          href="https://pixinvent.com/"
          target="_blank">
          <span [data-feather]="'link'"
          [class]="'mr-25'"></span>
          <span>{{ badgeText || "Link Badge" | translate }}</span>
        </a>
      }
      @if (badgeType === badgeTypeEnum.clickable) {
        <a
          class="badge-clickable-link"
          (click)="onBadgeClicked()">
          @if (!badgeIcon) {
            <span
              [data-feather]="'link'"
            [class]="'mr-25'"></span>
          }
          @if (badgeIcon) {
            <span
              [data-feather]="badgeIcon"
            [class]="'mr-25'"></span>
          }
          {{ badgeText || "Link Badge" | translate }}
        </a>
      }
    </div>
  }
</div>

@if (badgeType === badgeTypeEnum.trafficLigth) {
  <div
    class="d-flex">
    @for (item of badgeTrafficLightInternalClass; track item; let last = $last) {
      <div
        [class]="'badge badge-pill trafficLigth ' + item"
       [ngClass]="{
      'badge-glow': badgeColorType === badgeColorTypeEnum.glow,
      'margin-right-small': !last
    }"
        [ngbTooltip]="badgeToolTip"
      style="width: 32px; height: 32px; display: block !important"></div>
    }
  </div>
}